export default "__VITE_ASSET__0902c24a__"